import types from './ActionTypes';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import postData from 'Utils/PostData';
import patchData from 'Utils/PatchData';
import deleteData from 'Utils/DeleteData';

//interfaces
import { ICourseGroup, IGroupConcept } from 'store/StateInterfaces';


//Groups Actions

export function loadCourseGroupsRequest(courseid: number) {
    return dispatch => {
        const url = `/courseware/api/course/${courseid}/groups/?format=json`;
        return fetch(url)
            .then(response => response.json())
            .then(response => {
                let groups = response === "" ? [] : response;
                dispatch(loadCourseGroupsSuccess(courseid, groups));
            })
            .catch(error => {
                displayGlobalMessage("Group Loading Failed", 'error');
                throw (error);
            })

    }
}


export function loadCourseGroupsSuccess(courseid: number, groups: Array<ICourseGroup>) {
    return {
        type: types.LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
        groups
    }
}



export function addCourseGroupRequest(courseid: number, data) {
    return dispatch => {
        const url = `/courseware/api/course/${courseid}/add_group/?format=json`;
        return postData(url, data, "FormData")
            .then(response => {
                dispatch(addCourseGroupSuccess(courseid, response));
                displayGlobalMessage('Chapter Added Successfully at the bottom', 'success')
            })
            .catch(error => {
                displayGlobalMessage("Chapter Adding Failed", 'error');
                throw (error);
            })

    }
}


export function addCourseGroupSuccess(courseid: number, group: ICourseGroup) {
    return {
        type: types.ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
        group
    }
}

export function editCourseGroupRequest(courseid: number, groupid: number, data: FormData) {
    return dispatch => {

        const url = `/courseware/api/group/${groupid}/?format=json`;
        return patchData(url, data, "FormData")
            .then(response => {
                dispatch(editCourseGroupSuccess(courseid, groupid, response));
                displayGlobalMessage('Chapter info Updated Successfully', 'success');
            })
            .catch(error => {
                displayGlobalMessage("Chapter editing Failed", 'error');
                throw (error);
            })

    }
}


export function editCourseGroupSuccess(courseid: number, groupid: number, data) {
    return {
        type: types.EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
        groupid,
        data
    }
}

export function deleteCourseGroupRequest(courseid: number, groupid: number) {
    return dispatch => {
        const url = `/courseware/api/group/${groupid}/?format=json`;
        return deleteData(url, {})
            .then(response => {
                dispatch(deleteCourseGroupSuccess(courseid, groupid));
                displayGlobalMessage('Chapter Deleted Successfully', 'success')
            })
            .catch(error => {
                displayGlobalMessage("Chapter delete Failed", 'error');
                throw (error);
            })
    }
}


export function deleteCourseGroupSuccess(courseid: number, groupid: number) {
    return {
        type: types.DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
        groupid
    }
}




export function reorderCourseGroupsRequest(courseid: number, formData, groups) {
    return dispatch => {
        const url = `/courseware/api/course/${courseid}/reorder_groups/?format=json`;
        return patchData(url, formData, "FormData")
            .then(response => {
                dispatch(reorderCourseGroupsSuccess(courseid, groups));
                displayGlobalMessage("Chapter reordered Successfully", 'success');
            })
            .catch(error => {
                displayGlobalMessage("Chapter reorder Failed", 'error');
                throw (error)
            })

    }
}


export function reorderCourseGroupsSuccess(courseid: number, groups) {
    return {
        type: types.REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
        groups
    }
}

// prashanth
export function reorderGlobalRequest(courseid: number, payload) {
    return dispatch => {
        const url = `/courseware/api/course/${courseid}/reorder_global/?format=json`;
        return postData(url, payload)
            .then(response => {
                if (response['success']) {
                    dispatch(reorderGlobalSuccess(courseid));
                    displayGlobalMessage("Chapter reordered Successfully", 'success');
                }
                else {
                    throw (response);
                }
            })
            .catch(error => {
                displayGlobalMessage("Chapter reorder Failed", 'error');
                throw (error)
            })
    }
}


export function reorderGlobalSuccess(courseid: number) {
    return {
        type: types.REORDER_GLOBAL_INSTRUCTOR_COURSE_GROUPS_SUCCESS,
        courseid,
    }
}




// Concept Actions

// load
export function loadGroupConceptsRequest(groupid) {
    return dispatch => {
        const url = `/courseware/api/group/${groupid}/concepts/?format=json`;
        return fetch(url)
            .then(res => res.json())
            .then(res => {
                let concepts = res === "" ? [] : res;
                dispatch(loadGroupConceptsSuccess(groupid, concepts));
            })
            .catch(err => {
                displayGlobalMessage("Load Concept Failed", "error");
                throw (err);
            });

    }
}



export function loadGroupConceptsSuccess(groupid: number, concepts: Array<IGroupConcept>) {
    return {
        type: types.LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS,
        groupid,
        concepts
    }
}


// delete
export function deleteGroupConceptsRequest(groupid: number, conceptid: number) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptid}/?format=json`;
        return deleteData(url, {})
            .then(response => {
                dispatch(deleteGroupConceptsSuccess(groupid, conceptid));
                displayGlobalMessage('Concept Deleted Successfully', 'success')
            })
            .catch(error => {
                displayGlobalMessage("Concept delete Failed", 'error');
                throw (error);
            })

    }
}


export function deleteGroupConceptsSuccess(groupid: number, conceptid: number,) {
    return {
        type: types.DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS,
        conceptid,
        groupid
    }
}


// publish
export function publishGroupConceptsRequest(groupid: number, conceptid: number) {
    return dispatch => {
        const url = `/courseware/api/concept/${conceptid}/publish/?format=json`;
        return postData(url)
            .then(response => {
                dispatch(publishGroupConceptsSuccess(groupid, conceptid));
            })
            .catch(error => {
                displayGlobalMessage("Concept publish Failed", 'error');
                throw (error);
            })

    }
}


export function publishGroupConceptsSuccess(groupid: number, conceptid: number,) {
    return {
        type: types.PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS,
        conceptid,
        groupid
    }
}


// reorder
export function reorderGroupConceptsRequest(groupid: number, formData, concepts) {
    return dispatch => {
        const url = `/courseware/api/group/${groupid}/reorder_concepts/?format=json`;
        return patchData(url, formData, "FormData")
            .then(response => {
                dispatch(reorderGroupConceptsSuccess(groupid, concepts));
                displayGlobalMessage("Concept reordered Success", 'success');
            })
            .catch(error => {
                displayGlobalMessage("Concept reorder Failed", 'error');
                throw (error)
            })

    }
}


export function reorderGroupConceptsSuccess(groupid: number, concepts) {
    return {
        type: types.REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS,
        concepts,
        groupid
    }
}

// add
export function addGroupConceptsRequest(groupid: number, type: string, sectionData: any, elemData: any) {
    return dispatch => {
        const secUrl = `/courseware/api/group/${groupid}/add_concept/?format=json`;
        // make hit for adding section

        return postData(secUrl, sectionData, 'FormData')
            .then((res) => {
                displayGlobalMessage('Section created successfully', 'success');
                if (type !== 'section') {
                    // make a hit for learning element
                    const elemUrl = `/courseware/api/concept/${res.id}/add_${type}/?format=json`;
                    return postData(elemUrl, elemData, 'FormData')
                        .then((elemRes) => {
                            displayGlobalMessage('Learning element added successfully', 'success');
                            dispatch(addGroupConceptsSuccess(groupid, res));
                        })
                        .catch(err => {
                            displayGlobalMessage('Learning element adding failed', 'error');
                        })
                }
                else {
                    dispatch(addGroupConceptsSuccess(groupid, res));
                }

            })
            .catch(err => {
                displayGlobalMessage('Adding Concept Failed', 'error');
                throw (err);
            })
    }
}


export function addGroupConceptsSuccess(groupid: number, data: IGroupConcept) {
    return {
        type: types.ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS,
        data,
        groupid
    }
}